<template>
  <!-- 赤韵数笺 -->
  <div class="v11-style" :style="getStyleContainerStyle()" @click="handleClick">
    <img class="header-bg" src="@/assets/img/style11/header_bg.png" v-if="!isMobile" />
    <div class="header-left" v-if="!isMobile">
      <!-- <img class="header-bg" src="@/assets/img/style2/header_left_bg.png" /> -->
      <div class="header-left-show-infos">
        <div class="info-item">
          <p :style="getHeaderInfopStyle()">
            <i class="iconfont icon-chaye"></i>
            湿度 {{ humidity }} %
          </p>
        </div>
        <div class="info-item">
          <p :style="getHeaderInfopStyle()">空气质量：{{ getAqiLevel(air_quality) }}</p>
        </div>
        <div
          class="icon"
          :style="getHeaderInfopStyle()"
          v-if="icon1?.iconUrl"
          @click.stop="handleJump(icon1?.url)"
        >
          <el-tooltip :content="headerIcon1Name" placement="bottom">
            <img :src="icon1.iconUrl" alt="" />
          </el-tooltip>
        </div>
        <div class="info-item" @click="toggleChartShow">
          <p :style="getHeaderInfopStyle()">
            <el-tooltip :content="!isHideAllCharts ? '隐藏全部图表' : '显示全部图表'" placement="bottom">
              <i :class="!isHideAllCharts ? 'iconfont icon-huabankaobei-' : 'iconfont icon-yanjing-guan'"></i>
            </el-tooltip>
          </p>
        </div>
      </div>
    </div>
    <div class="header-middle" v-if="!isMobile">
      <div class="header-middle-filter"></div>
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(26, $store) + 'px',
          lineHeight: $h_Ratio(style.height - 20, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>

      <div class="spotlight-ct">
        <div class="spotLight1"></div>
        <div class="spotLight2"></div>
      </div>
    </div>
    <div class="header-right" v-if="!isMobile">
      <!-- <img class="header-bg" src="@/assets/img/style2/header_right_bg.png" /> -->
      <div class="header-right-show-infos">
        <div class="info-item1">
          <p :style="getHeaderInfopStyle()">{{ cityName }}</p>
          <p :style="getHeaderInfopStyle()">{{ skycon }}</p>
          <p :style="getHeaderInfopStyle()">{{ `${city}  ${weather}  ${temperature}°C` }}</p>
        </div>
        <div class="info-item3">
          <div
            class="icon"
            :style="getHeaderInfopStyle()"
            v-if="icon2?.iconUrl"
            @click.stop="handleJump(icon2?.url)"
          >
            <el-tooltip :content="headerIcon2Name" placement="bottom">
              <img :src="icon2.iconUrl" alt="" />
            </el-tooltip>
          </div>
        </div>
        <div class="info-item2">
          <div class="info-item2-wrapper">
            <div
              :style="{
                fontSize: $w_Ratio(27, $store) + 'px',
              }"
              class="digital-clock-css"
            >
              {{ currentTime }}
            </div>
            <div
              :style="{
                fontSize: $w_Ratio(13, $store) + 'px',
              }"
              class="digital-clock-css"
            >
              {{ currentday }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="right-icon"
      :style="getRightInfopStyle()"
      v-if="icon3?.iconUrl"
      @click.stop="handleJump(icon3?.url)"
    >
      <div>
        <img :src="icon3.iconUrl" alt="" />
      </div>
      <div class="right-name">
        {{ headerIcon3Name }}
      </div>
    </div>
    <!-- 数字人 -->
    <vue-draggable-resizable
      v-if="digitalhumanShow"
      :w="180"
      :h="330"
      :x="digitalhumanSite === 'right' ? initialX : initialLeftX"
      :y="initialY"
      :resizable="false"
      :handles="[]"
      class="draggable-digitalhuman"
      ref="digitalhumanRef"
      :style="{ 'pointer-events': robotShow ? 'none' : 'auto' }"
    >
      <digitalhuman
        :src="digitalhumanSrc"
        :robotShow="robotShow"
        @update-robot-show="handleUpdateRobotShow"
      />
    </vue-draggable-resizable>
    <img
      @click="handleRobotClick"
      src="@/assets/img/robot.png"
      alt=""
      class="robot"
      :class="digitalhumanShow && robotShow ? 'show' : ''"
    />
    <!-- 手机端 -->
    <img class="header-bg" src="@/assets/img/mobile/style11/header_bg.png" v-if="isMobile" />

    <div class="header-middle" v-if="isMobile">
      <div class="header-middle-filter"></div>
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(22, $store) + 'px',
          lineHeight: $h_Ratio(style.height - 16, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>
      <div class="spotlight-ct">
        <div class="spotLight1"></div>
        <div class="spotLight2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { websocket } from '../../../agent/websocket.js';
// import { reloadPageData } from '../../../mixins/reloadPageData.js';
import provinceCoordinate from '../../charts/EarthCharts/Earth1Charts/provinceCoordinate';
import { request } from '../../../common/request';
import jsonp from 'jsonp';
import VueDraggableResizable from 'vue-draggable-resizable';
import digitalhuman from '../../../agent/digitalhuman.vue';
export default {
  name: 'V11Style',
  components: {
    VueDraggableResizable,
    digitalhuman,
  },
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      style: {
        height: 80,
      },
      timeString: '',
      dateString: '',
      cityName: '',
      province: '',
      city: '',
      aqiName: '', // 空气质量
      humidity: '',
      air_quality: '',
      temperature: '',
      weather: '',
      icon1: { isShowIcon: false, iconUrl: '', url: '' }, // 图标1
      icon2: { isShowIcon: false, iconUrl: '', url: '' }, // 图标2
      icon3: { isShowIcon: false, iconUrl: '', url: '' }, // 图标3
      headerIcon2Name: '', // 跳转图标2名称
      headerIcon3Name: '', // 跳转图标3名称
      headerIcon1Name: '', // 跳转图标1名称
      headerLon: '',
      headerLat: '',
      digitalhumanShow: false,
      digitalhumanSrc: '',
      currentTime: '',
      currentday: '',
      digitalshow: '',
      aiUrl: '',
      digitalhumanSite: '',
      robotShow: false, // 初始化robotShow状态，默认为false
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        this.headerIcon3Name = val.propertyData.headerIcon3.value.name;
        this.onConfigurationChange();
        this.digitalhumanShow = val.propertyData.digitalHuman.value.isShow;
        this.digitalhumanSrc = val.propertyData.digitalHuman.value.digitalhumanSrc;
        this.aiUrl = val.propertyData.digitalHuman.value.aiUrl;
        this.digitalhumanSite = val.propertyData.digitalHuman.value.position;
      },
    },
  },
  created() {
    this.onConfigurationChange();
    this.autoGetTime();
  },
  mounted() {
    setTimeout(() => {
      this.getWeather();
    }, 200);
    // 从配置中获取数字人相关配置，添加安全的默认值处
    const digitalHumanConfig = this.Configuration.propertyData?.digitalHuman?.value || {};
    if (digitalHumanConfig && digitalHumanConfig.isShow == true) {
      setTimeout(() => {
        this.digitalhumanSrc = digitalHumanConfig?.digitalhumanSrc;
        this.aiUrl = digitalHumanConfig?.aiUrl;
        websocket.connectSocket(digitalHumanConfig?.aiUrl);
        this.digitalhumanSite = digitalHumanConfig?.position;
        this.digitalhumanShow = digitalHumanConfig?.isShow;
      }, 500);
    }

    this.headerIcon2Name = this.Configuration.propertyData?.headerIcon2?.value?.name;
    this.headerIcon1Name = this.Configuration.propertyData?.headerIcon1?.value?.name;
    this.headerIcon3Name = this.Configuration.propertyData?.headerIcon3?.value?.name;
    this.headerLon = this.Configuration.propertyData?.headerLngLatData?.value?.lon;
    this.headerLat = this.Configuration.propertyData?.headerLngLatData?.value?.lat;

    this.updateTime();

    setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  methods: {
    // // 直接处理机器人点击事件
    handleRobotClick() {
      this.robotShow = false;
    },
    // 处理来自digitalhuman组件的updateRobotShow事件
    handleUpdateRobotShow(show) {
      this.robotShow = show;
    },
    getNoWeather(weather) {
      let weat = '';
      if (weather == 'CLEAR_DAY') weat = '晴';
      else if (weather == 'CLEAR_NIGHT') weat = '晴';
      else if (weather == 'CLOUDY') weat = '阴';
      else if (weather == 'PARTLY_CLOUDY_DAY' || weather == 'PARTLY_CLOUDY_NIGHT' || weather == 'CLOUDY')
        weat = '多云';
      else if (weather == 'LIGHT_RAIN' || weather == 'MODERATE_RAIN') weat = '小雨';
      else if (weather == 'STORM_RAIN' || weather == 'STORM_RAIN') weat = '大雨';
      else if (weather == 'FOG') weat = '雾';
      else if (weather == 'LIGHT_SNOW' || weather == 'MODERATE_SNOW') weat = '小雪';
      else if (weather == 'HEAVY_SNOW' || weather == 'STORM_SNOW') weat = '大雪';
      else weat = '晴';
      return weat;
    },
    getAqiLevel(aqi) {
      if (aqi <= 50) return '优';
      if (aqi <= 100) return '良';
      if (aqi <= 150) return '轻度污染';
      if (aqi <= 200) return '中度污染';
      if (aqi <= 300) return '重度污染';
      return '良';
    },
    updateTime() {
      const now = new Date();
      const hours = this.formatTimeUnit(now.getHours());
      const minutes = this.formatTimeUnit(now.getMinutes());
      const seconds = this.formatTimeUnit(now.getSeconds());
      const year = now.getFullYear();
      const month = this.formatTimeUnit(now.getMonth() + 1);
      const day = this.formatTimeUnit(now.getDate());
      this.currentTime = `${hours}:${minutes}:${seconds}`;
      this.currentday = `${year}-${month}-${day}`;
    },
    formatTimeUnit(unit) {
      return unit < 10 ? `0${unit}` : unit;
    },
    handleJump(url) {
      if (url) {
        window.open(url);
      } else {
        this.$ElMessage.warning('请配置地址！');
      }
    },
    toggleChartShow() {
      if (!this.isHideAllCharts) {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'hide',
          isAll: true,
        });
      } else {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'norm',
          isAll: true,
        });
      }
    },
    onConfigurationChange() {
      this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;
      this.cityName = this.Configuration.propertyData.cityName.value;
      this.icon1 = this.Configuration?.propertyData?.headerIcon1?.value;
      this.icon2 = this.Configuration?.propertyData?.headerIcon2?.value;
      this.icon3 = this.Configuration?.propertyData?.headerIcon3?.value;
    },
    getWeather() {
      let params = {
        url:
          `https://devapi.qweather.com/v7/weather/now?location=` +
          this.headerLon +
          ',' +
          this.headerLat +
          `&key=0a93d2ba25c2485ba4602978df50f75a`,
        method: 'GET',
      };

      this.axios(params).then(res => {
        this.humidity = res.data.now.humidity;
        this.skycon = res.data.now.text;
        this.temperature = res.data.now.temp;
      });
    },
    getHeaderInfopStyle(fs = 12, pt = 15) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
        // transform: `scale(${this.$w_Ratio(1, this.$store)})`,
      };
    },
    getRightInfopStyle(fs = 14, pt = 15) {
      return {
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    autoGetTime() {
      let padaDate = function (value) {
        // 时间不足十补零
        return value < 10 ? '0' + value : value;
      };
      setInterval(() => {
        const date = new Date();
        // console.log(date);
        const year = date.getFullYear(); //存储年
        const month = padaDate(date.getMonth() + 1); //存储月份
        const day = padaDate(date.getDate()); //存储日期
        const hours = padaDate(date.getHours()); //存储时
        const minutes = padaDate(date.getMinutes()); //存储分
        const seconds = padaDate(date.getSeconds()); //存储秒
        //返回格式化后的日期
        this.dateString = year + 'D' + month + 'D' + day;
        this.timeString = hours + 'T' + minutes + 'T' + seconds;
      }, 1000);
    },
  },
  computed: {
    ...mapState({
      isHideAllCharts: state => state.ProjectInfo.isHideAllCharts,
      isMobile: state => state.isMobile,
      pointList: state => state.pointList,
    }),
    initialX() {
      // 计算右下角位置的 X 坐标
      if (typeof window !== 'undefined') {
        return window.innerWidth - 190;
      }
      return 1730; // 默认值，适用于 1920px 宽度的屏幕
    },
    initialY() {
      // 计算右下角位置的 Y 坐标
      if (typeof window !== 'undefined') {
        // 如果屏幕宽度小于1400px，返回固定高度357
        if (window.innerWidth < 1400) {
          return window.innerHeight - 365;
        }
        return window.innerHeight - 400;
      }
      return 680; // 默认值，适用于 1080px 高度的屏幕
    },
    initialLeftX() {
      // 计算左下角位置的 X 坐标
      if (typeof window !== 'undefined') {
        return 10; // 左下角固定在左侧10px位置
      }
      return 10; // 默认值
    },
  },
  Configuration: {
    componentTitle: '赤韵数笺',
    componentName: 'V11Style',
    componentOverViewImg: './img/styles/style11.png',
    backgroundImg: './img/backgrounds/background_img/V11.png',
    backgroundImgMobile: `./img/backgrounds/background_img/mobile/V3.png`,
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: 'rgba(25, 36, 45, 0)',
        lable: '头部背景颜色',
      },
      menuStyle: {
        value: {
          height: 75,
          width: 700,
        },
      },
      headerIcon1: {
        propertyComponentName: 'HeaderIcon1Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      headerIcon2: {
        propertyComponentName: 'HeaderIcon2Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      headerIcon3: {
        propertyComponentName: 'HeaderIcon3Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      digitalHuman: {
        propertyComponentName: 'AiCustomerService',
        value: {
          isShow: false,
          aiUrl: 'https://llmapi.xyabcd.com',
          digitalhumanSrc: 'https://llmapp.xyabcd.com/digitalhuman/02a7537305e1484097b75226c5e8502e',
          position: 'right',
        },
      },
    },
  },
};
</script>
<style lang="scss">
.robot {
  position: fixed;
  right: -10%;
  bottom: 15%;
  z-index: 40;
  transition: all 0.5s;
  cursor: pointer;
  &.show {
    right: 0;
    transition: all 0.5s;
  }
}
/* 拖拽组件样式 */
.draggable-digitalhuman {
  z-index: 9999 !important;
  cursor: move;
  position: fixed !important;
  border: none !important;
}

.draggable-digitalhuman .vdr {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.draggable-digitalhuman .vdr:hover {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.draggable-digitalhuman .vdr.active {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* 移除所有拖拽手柄和边框效果 */
.draggable-digitalhuman .vdr .handle {
  display: none !important;
}

.draggable-digitalhuman .vdr .handle-tl,
.draggable-digitalhuman .vdr .handle-tm,
.draggable-digitalhuman .vdr .handle-tr,
.draggable-digitalhuman .vdr .handle-ml,
.draggable-digitalhuman .vdr .handle-mr,
.draggable-digitalhuman .vdr .handle-bl,
.draggable-digitalhuman .vdr .handle-bm,
.draggable-digitalhuman .vdr .handle-br {
  display: none !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@font-face {
  font-family: 'DS-Digital';
  src: url('../../../assets/font/DS-DIGIT.TTF'); /***兼容ie9***/
}
.call-frame {
  overflow: hidden;
  position: relative;
  bottom: 62px;
  transition: all ease-in-out 0.6s;
  transform: translateY(70%);
  height: 560px;
  width: 94%;
  opacity: 0;
  img {
    position: absolute;
    z-index: 1;
    height: 560px;
  }
  &.active-list {
    transform: translateY(1%);
    height: 560px;
    opacity: 1;
  }
  .bg-top {
    top: 0;
    left: 0;
    right: 0;
    height: 40px;
  }

  .bg-left {
    top: 40px;
    left: 0;
    bottom: -2px;
    width: 9px;
    height: 85.7%;
  }

  .bg-right {
    top: 40px;
    right: 0;
    bottom: 0;
    height: 85.6%;
  }
  .bg-bot {
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
  }
}

.v11-style {
  z-index: 200;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  color: #c68a34;
  display: flex;
  justify-content: space-between;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.765) 45%, transparent 100%);
  .header-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .header-left {
    max-width: 460px;
    width: 25%;
    height: 100%;
    position: relative;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-left-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: space-between;

      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.33%;
        height: 100%;
      }
    }
  }

  .customer {
    z-index: 1000;
    position: absolute;
    width: 363px;
    height: 630px;
    display: flex;

    align-content: stretch;
    flex-direction: column;
    align-items: center;
    bottom: -1220%;

    iframe {
      position: absolute;
      top: 12px;
      left: 9.9px;
      max-width: 94%;
      z-index: 2;
      max-height: 90%;
      border-radius: 22px 22px 0 0;
    }
    .call-button {
      position: absolute;
      width: 120px;
      height: 164px;
      overflow: hidden;
      bottom: 0;
      background: url('../../../assets/img/ai-model/ai_base.png') no-repeat;
      background-size: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        position: absolute;
      }
      .call-img-Hiyori {
        max-width: 42%;
        max-height: 44%;
        left: 46px;
      }
      .call-img-Haru {
        top: 40px;
        left: 22px;
        max-width: 80%;
        max-height: 80%;
      }
      .call-img-Mao {
        top: 52px;
        left: 38px;
        max-width: 46%;
        max-height: 40%;
      }
      .call-img-Natori {
        max-width: 40%;
        max-height: 40%;
        top: 54px;
        left: 43px;
      }
    }

    .ai-button {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .right-icon {
    z-index: 1000;
    background: #031943;
    position: absolute;
    right: 0;
    bottom: -900%;
    width: 26px;
    height: 80px;
    border-radius: 6px 0 0 6px;
    border-top: 1px solid #148ddd;
    border-bottom: 1px solid #148ddd;
    border-left: 1px solid #148ddd;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    .right-name {
      color: #fff;
      line-height: 28px;
      writing-mode: vertical-lr;
    }
    img {
      display: none;
    }
  }
  .right-icon:hover {
    width: 165.6px;
    height: 144px;
    padding: 0 10px;
    justify-content: space-between;
    border: none;
    .right-name {
      line-height: 16px;
      position: relative;
      left: 6px;
    }
    img {
      display: block;
      width: 150px;
    }
  }
  .header-middle {
    width: 34.5%;
    height: 100%;
    flex-shrink: 1;
    position: absolute;
    left: 50.4%;
    transform: translateX(-50%);
    overflow: hidden;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      color: #f1f8f7;
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;

      p {
        color: #fff;
        background-image: linear-gradient(to bottom, #ffffff, #f2f9ff, #c5daeb);
        -webkit-background-clip: text;
        -moz-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        -moz-text-fill-color: transparent;
        text-shadow: 0 0 0.04em #ffffff, 0 0 0.18em rgb(255 126 126 / 35%);
        letter-spacing: 0.1em;
      }
    }
    .spotlight-ct {
      position: absolute;
      bottom: 2%;
      left: 50%;
      transform: translateX(-49.5%);
      width: 100%;
      height: 40%;
      overflow: hidden;
      border-radius: 20px;
      box-shadow: 0 0 20px rgba(255, 255, 255, 0);
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 20%,
        rgba(255, 255, 255, 0) 80%,
        rgba(255, 255, 255, 0) 100%
      );
      mask-image: linear-gradient(
        to right,
        transparent 0%,
        rgba(0, 0, 0, 0.8) 10%,
        rgba(0, 0, 0, 0.8) 90%,
        transparent 100%
      );
      .spotLight1 {
        position: absolute;
        top: 65%;
        left: 50%;
        display: block;
        width: 28%;
        height: 20%;
        transform: translate(-50%, -50%);
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #fefbfb 12%,
          rgba(189, 91, 87, 0) 60%,
          rgba(189, 91, 87, 0) 69%
        );
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      .spotLight2 {
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #fefbfb 9%,
          rgba(189, 91, 87, 0) 75%,
          rgba(189, 91, 87, 0) 73%
        );
        width: 9%;
        height: 20%;
        position: absolute;
        top: 65%;
        left: 50%;
        display: block;
        width: 11%;
        height: 14%;
        transform: translate(-50%, -50%);
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      @keyframes titlelight {
        0% {
          left: -40%;
          opacity: 1;
          transform: scale(1.2, 1.3) translate(-50%, -50%);
        }
        35% {
          opacity: 0.7;
          transform: scale(1.6, 1.5) translate(-50%, -50%);
        }

        50% {
          opacity: 1;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }
        75% {
          opacity: 0.5;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }

        100% {
          left: 120%;
          opacity: 1;
          transform: scale(1.2, 1.2) translate(-50%, -50%);
        }
      }
    }
  }

  .header-right {
    max-width: 348px;
    width: 19%;
    height: 100%;
    position: relative;
    margin-right: 2%;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-right-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: space-between;

      .info-item1 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 33%;
        height: 100%;
        color: #c78b34;
      }
      .info-item3 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 15%;
        height: 100%;
      }
      .info-item1 p {
        margin-right: 10px;
      }

      .info-item2 {
        width: 28%;
        justify-content: flex-end;
        display: flex;
        color: #c78b34;
        height: 100%;
        .digital-clock-css {
          font-family: 'DS-Digital', serif;
        }
        .info-item2-wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
        }
      }
    }
  }
}
.icon {
  margin-right: 25px;

  img {
    cursor: pointer;
    min-width: 22px;
    min-height: 22px;
  }
}
.icon2 {
  margin-left: 0;
}
@media screen and (max-width: 1400px) {
  .call-frame {
    width: 86% !important;
  }
  .active-list {
    width: 86% !important;
  }
  .v3-style .customer iframe {
    max-height: 90% !important;
    top: 11px !important;
  }
  .customer {
    bottom: -1230% !important;
  }
}
@media screen and (min-width: 3300px) {
  .v11-style .header-right .header-right-show-infos .info-item2 {
    height: 60% !important;
  }
  .v3-style .header-right .header-right-show-infos .info-item2 .info-item2-wrapper {
    height: 100% !important;
  }
  .v3-style .header-left {
    max-width: 528px !important;
  }
}
</style>
